/**
 * Studio Booking · Shared helpers — extracted Oct 2026.
 * Keep this file for cross-module primitives that would otherwise
 * cause circular imports between the leaf modules.
 */

// Returns the tailwind border + bg + text classes for a booking status
// badge. Centralised so Bookings table, calendar focus dialog and crew
// bookings all stay visually consistent.
export function statusColor(s) {
  return {
    confirmed: "border-emerald-500 bg-emerald-50 text-emerald-800",
    pending_payment: "border-amber-500 bg-amber-50 text-amber-800",
    cancelled: "border-rose-500 bg-rose-50 text-rose-800",
    shoot_in_progress: "border-sky-500 bg-sky-50 text-sky-800",
  }[s] || "border-border";
}
